export interface IProduct {
  [key: string]: number | string | boolean | null | undefined | IProductIngredient[]
  productId: number
  brandId: string
  packagingId: string
  packagingName: string
  productName: string
  box: boolean
  halal: boolean
  wrap: boolean
  seal: boolean
  premixId: string
  unitPrice: number
  unit: string
  weight: number | string
  notificationNumber: string
  productStatus: string
  expiry: string
  type: string
  batchNumber?: string
  fillingAmount?: number | string | null
  fillingUnit?: string
  labelId?: string
  rank: number | null
  inventory: number | string
  productQty: number | null
  createdAt: string
  productIngredients: IProductIngredient[]
}

export class Product implements IProduct {
  [key: string]: number | string | boolean | null | undefined | IProductIngredient[]
  productId: number
  brandId: string
  packagingId: string
  packagingName: string
  productName: string
  box: boolean
  halal: boolean
  wrap: boolean
  seal: boolean
  premixId: string
  unitPrice: number
  unit: string
  weight: number | string
  notificationNumber: string
  productStatus: string
  expiry: string
  type: string
  batchNumber?: string
  fillingAmount?: number | string | null
  fillingUnit?: string
  labelId?: string
  rank: number | null
  inventory: number | string
  productQty: number | null
  createdAt: string
  productIngredients: IProductIngredient[]

  constructor({
    productId,
    productName,
    brandId,
    packagingId,
    packagingName,
    box,
    halal,
    wrap,
    seal,
    premixId,
    unitPrice,
    unit,
    weight,
    notificationNumber,
    productStatus,
    expiry,
    type,
    batchNumber,
    fillingAmount,
    fillingUnit,
    labelId,
    rank,
    inventory,
    productQty,
    createdAt,
    productIngredients,
  }: Partial<IProduct> = {}) {
    this.productId = productId || 0
    this.brandId = brandId || ''
    this.packagingId = packagingId || ''
    this.packagingName = packagingName || ''
    this.productName = productName || ''
    this.box = !!box
    this.halal = !!halal
    this.wrap = !!wrap
    this.seal = !!seal
    this.premixId = premixId || ''
    this.unitPrice = unitPrice || 0
    this.unit = unit || ''
    this.weight = weight || ''
    this.notificationNumber = notificationNumber || ''
    this.productStatus = productStatus || 'Active'
    this.expiry = expiry || ''
    this.type = type || TYPE_BARANG_JADI
    this.batchNumber = batchNumber || ''
    this.fillingAmount = fillingAmount ?? null
    this.fillingUnit = fillingUnit || ''
    this.labelId = labelId || ''
    this.rank = rank || null
    this.inventory = inventory || 0
    this.productQty = productQty || 0
    this.createdAt = createdAt || ''
    this.productIngredients = productIngredients || []
  }
}

export interface IProductIngredient {
  productIngredientId: string
  productId: number
  ingredientId: string
  ingredientName: string
  unit: string
  amount: number
}

export class ProductIngredient {
  productIngredientId: string
  productId: number
  ingredientId: string
  ingredientName: string
  unit: string
  amount: number

  constructor({
    productIngredientId,
    productId,
    ingredientId,
    ingredientName,
    unit,
    amount,
  }: Partial<IProductIngredient>) {
    this.productIngredientId = productIngredientId || ''
    this.productId = productId || 0
    this.ingredientId = ingredientId || ''
    this.ingredientName = ingredientName || ''
    this.unit = unit || ''
    this.amount = amount || 0
  }
}

export const TYPE_BARANG_JADI = 'BARANG_JADI'
export const TYPE_BARANG_SETENGAH_JADI = 'SETENGAH_JADI'
export const TYPE_SETENGAH_JADI = 'SETENGAH_JADI'
